import NotFoundBg from '@assets/images/not-found-bg.jpg'
import { Container } from '@/components/ui/container'
import { IconContainer } from '@/components/ui/icon-container'
import { SearchLgIcon } from '@/components/ui/icons'
import { useTranslation } from '@/translations/i18n'

export const NotFound = () => {
	const { t } = useTranslation()

	return (
		<Container
			className='grid grid-rows-[1fr] items-center justify-center'
			fullHeight
			style={{
				background: `url("${NotFoundBg}")`,
				boxShadow:
					'-1px -200px 2000px 399px rgba(255, 255, 255, 0.9) inset'
			}}
		>
			<title>{t('not_found:page_title_meta')}</title>
			<div className='relative grid max-w-[1024px] grid-cols-[1fr] items-center justify-items-center gap-6'>
				<IconContainer>
					<SearchLgIcon />
				</IconContainer>
				<h1 className='font-semibold text-display-xl text-neutral-900'>
					{t('not_found:title')}
				</h1>
				<p className='mb-4 text-neutral-600 text-xl'>
					{t('not_found:subtitle')}
				</p>
				{/*<ButtonLink variant={'primary'} size={'lg'} to={routes.SSO_LOGIN.path}>
                    {t('not_found:cta')}
                </ButtonLink>*/}
			</div>
		</Container>
	)
}

NotFound.displayName = 'NotFound'
